import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sinking-fund-calculator',
  component: () => import('../../routes/SinkingFundCalculator.svelte'),
  card: {
    id: 'sinking-fund-calculator',
    title: 'Sinking Fund Calculator',
    description: 'Calculate how much you need to save regularly to reach a future financial goal. Set a target amount, interest rate, and time horizon to see your required contributions.',
    icon: 'savings',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/sinking-fund-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Sinking Fund Calculator – Save for a Future Goal',
    description: 'Free sinking fund calculator to plan regular savings contributions toward a future goal. Enter your target amount, expected return, and time horizon to find out how much to save each period.',
  },
};

export default meta;
